import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { injectIntl, defineMessages } from 'react-intl'
import { deleteGroup } from '../../common/groups/actions'
import EmptyList from '../components/EmptyList'
import Button from '../components/Button'

const GroupsList = ({ groups, deleteGroup, intl }) => (
  <div className="groups-list">
    {
      groups.length ?
        groups.map(group => (
          <div className="column-direction" key={group.id}>
            <div className="item-box">
              <Link to={`/app/groups/${group.id}`}>
                {group.name}
              </Link>
              <div className="float-right">
                <Link to={`/app/edit-group/${group.id}`}>
                  <Button>
                    {intl.formatMessage(messages.edit)}
                  </Button>
                </Link>
                <Button
                  negative
                  className="disable-spacing-right"
                  onClick={() => deleteGroup(group.id)}
                >
                  {intl.formatMessage(messages.delete)}
                </Button>
              </div>
            </div>
          </div>
        ))
      :
        <EmptyList
          title={intl.formatMessage(messages.noClasses)}
        />
    }
  </div>
)

GroupsList.defaultProps = {
  groups: [],
}

GroupsList.propTypes = {
  intl: PropTypes.object.isRequired,
  groups: PropTypes.array,
  deleteGroup: PropTypes.func.isRequired,
}

const enhance = compose(
  connect(() => ({}), { deleteGroup }),
  injectIntl,
)

export default enhance(GroupsList)

const messages = defineMessages({
  edit: {
    id: 'groups.list.edit',
    defaultMessage: 'Upraviť',
  },
  delete: {
    id: 'groups.list.delete',
    defaultMessage: 'Vymazať',
  },
  noClasses: {
    id: 'groups.list.noClasses',
    defaultMessage: 'Zatiaľ nemáte vytvorené žiadne triedy.',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/GroupsList.js